import { Component, OnInit } from '@angular/core';
import { AppStorageService } from '@shared/storage/app-storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.page.html',
  styleUrls: ['./logout.page.scss'],
})
export class LogoutPage implements OnInit {

  constructor(private appStorageService:AppStorageService, private router:Router) { }

  ngOnInit() {
   this.appStorageService.clearToken(); 
  }
  goToLogin(){
    this.router.navigate(["/account/login"])
  }
}
